export default "__VITE_ASSET__6fc4f046__"